import { combineReducers } from "redux";
import * as observadorsReducer from "./observadors";
import * as indretsReducer from "./indrets";
import * as individusReducer from "./individus";
import * as usuarisReducer from "./usuaris";
import * as introduccioReducer from "./introduccio";
import * as visualitzacioReducer from "./visualitzacio";
import * as fenofasesReducer from "./fenofases";
import * as especiesReducer from "./especies";
import * as generesReducer from "./generes";
import * as collectiusReducer from "./collectius";
import * as varietatsReducer from "./varietats";
import * as subEspeciesReducer from "./subEspecies";
import * as regnesReducer from "./regnes";
import * as classesReducer from "./classes";
import * as titolApartatReducer from "./titolApartat";
import * as municipisReducer from "./municipis";
import * as menuLateralReducer from "./menuLateral";
import * as cercaVistesReducer from "./cercaVistes";

const rootReducer = combineReducers({
  observadors: observadorsReducer.default,
  indrets: indretsReducer.default,
  individus: individusReducer.default,
  usuaris: usuarisReducer.default,
  introduccio: introduccioReducer.default,
  fenofases: fenofasesReducer.default,
  especies: especiesReducer.default,
  generes: generesReducer.default,
  collectius: collectiusReducer.default,
  regnes: regnesReducer.default,
  classes: classesReducer.default,
  varietats: varietatsReducer.default,
  subEspecies: subEspeciesReducer.default,
  visualitzacio: visualitzacioReducer.default,
  titolApartat: titolApartatReducer.default,
  menuLateral: menuLateralReducer.default,
  municipis: municipisReducer.default,
  cercaVistes: cercaVistesReducer.default
});

export default rootReducer;

export const getObservadorsAsArray = state =>
  observadorsReducer.getObservadorsAsArray(state.observadors);

export const getObservadorsUsuari = state =>
  observadorsReducer.getObservadorsUsuari(state.observadors);

export const getObservadorsEspecies = state =>
  observadorsReducer.getObservadorsEspecies(state.observadors);

export const getObservadorsActius = state =>
  observadorsReducer.getObservadorsActius(state.observadors);

export const getObservadorsInactius = state =>
  observadorsReducer.getObservadorsInactius(state.observadors);

export const getPeticioObservadorsEnCurs = state =>
  observadorsReducer.getPeticioEnCurs(state.observadors);

export const getObservadorPerId = state =>
  observadorsReducer.getObservadorPerId(state.observadors);

export const getIdObservadorLlista = state =>
  observadorsReducer.getIdObservador(state.observadors);

export const getDadesObservador = state =>
  observadorsReducer.getDadesObservador(state.observadors);

export const getPeticioObservadorsError = state =>
  observadorsReducer.getPeticioError(state.observadors);

export const getPeticioEnCurs = state =>
  observadorsReducer.getPeticioEnCurs(state.observadors);

export const getPeticioEnviarFormulariEnCurs = state =>
  observadorsReducer.getPeticioEnviarFormulariEnCurs(state.observadors);

export const getRols = state => observadorsReducer.getRols(state.observadors);
export const getMostrarErrors = state =>
  observadorsReducer.getMostrarErrors(state.observadors);
export const getDadesEditades = state =>
  observadorsReducer.getDadesEditades(state.observadors);

export const getDadesOriginals = state =>
  observadorsReducer.getDadesOriginals(state.observadors);

export const getIndretsIndividusFenofasesObservador = state =>
  observadorsReducer.getIndretsIndividusFenofases(state.observadors);

export const getPeticioIndividusEnCurs = state =>
  individusReducer.getPeticioIndividusEnCurs(state.individus);

export const getIndividusPerIndret = individusReducer.getIndividusPerIndret;
export const getPeticioIndividusError = state =>
  individusReducer.getPeticioIndividusError(state.individus);

export const getUsuari = state => usuarisReducer.getUsuari(state.usuaris);
export const getIdUsuari = state => usuarisReducer.getIdUsuari(state.usuaris);
export const getIdObservador = state =>
  usuarisReducer.getIdObservador(state.usuaris);

export const getDataIntroduccioAsMoment = state =>
  introduccioReducer.getDataAsMoment(state.introduccio);

export const getIdObservadorIntroduccio = state =>
  introduccioReducer.getIdObservador(state.introduccio);

export const getIdEspecieIntroduccio = state =>
  introduccioReducer.getIdEspecie(state.introduccio);

export const getPeticioIntroduccioEnCurs = state =>
  introduccioReducer.getPeticioEnCurs(state.introduccio) ||
  observadorsReducer.getPeticioEnCurs(state.observadors);

export const getMostrarComentari = state => state.introduccio.mostrarCometari;

export const getPeticioIntroduccioError = state =>
  introduccioReducer.getPeticioError(state.introduccio);

export const getIntroduccioValors = state =>
  introduccioReducer.getValors(state.introduccio);

export const getDataDarreraIntroduccio = state =>
  introduccioReducer.getDataDarreraIntroduccio(state.introduccio);

//CLASSES
export const getTitolsClasses = state =>
  classesReducer.getClassesIntroduccio(state.classes);

export const getTitolsClassesAsArray = state =>
  classesReducer.getClassesIntroduccioAsArray(state.classes);

export const getTotesClasses = state =>
  classesReducer.getLlistatClasses(state.classes);

export const getClassesAsArray = state =>
  classesReducer.getClassesAsArray(state.classes);

//ESPECIES
export const getEspeciesAsArray = state =>
  especiesReducer.getEspeciesAsArray(state.visualitzacio);

export const getTotesEspecies = state =>
  visualitzacioReducer.getEspecies(state.visualitzacio);

export const getTotesFenofases = state =>
  visualitzacioReducer.getFenofases(state.visualitzacio);

export const getIdEspecie = state =>
  visualitzacioReducer.getIdEspecie(state.visualitzacio);

export const getIdFenofase = state =>
  visualitzacioReducer.getIdFenofase(state.visualitzacio);

export const getDataInici = state =>
  visualitzacioReducer.getDataInici(state.visualitzacio);

export const getDataFi = state =>
  visualitzacioReducer.getDataFi(state.visualitzacio);

export const getDataSeleccionada = state =>
  visualitzacioReducer.getDataSeleccionada(state.visualitzacio);

export const getDataIniciAsMoment = state =>
  visualitzacioReducer.getDataIniciAsMoment(state.visualitzacio);

export const getDataFiAsMoment = state =>
  visualitzacioReducer.getDataFiAsMoment(state.visualitzacio);

export const getDataSeleccionadaAsMoment = state =>
  visualitzacioReducer.getDataSeleccionadaAsMoment(state.visualitzacio);

export const getPeticioVisualitzacioEnCurs = state =>
  visualitzacioReducer.getPeticioEnCurs(state.visualitzacio);

export const getPeticioVisualitzacioError = state =>
  visualitzacioReducer.getPeticioError(state.visualitzacio);

export const getVisibilitatMenu = state =>
  visualitzacioReducer.getVisibilitatMenu(state.visualitzacio);

export const getVisibilitatObservacions = state =>
  visualitzacioReducer.getVisibilitatObservacions(state.visualitzacio);

export const getVisibilitatObservacionsByCamp = (state, camp) =>
  visualitzacioReducer.getVisibilitatObservacionsByCamp(
    state.visualitzacio,
    camp
  );

export const getTipusActiu = state =>
  visualitzacioReducer.getTipusActiu(state.visualitzacio);

export const getEspecieFenofaseSeleccionada = state =>
  visualitzacioReducer.getEspecieFenofaseSeleccionada(state.visualitzacio);

export const getTitolApartat = state =>
  titolApartatReducer.getTitolApartat(state);

export const getCercaVistes = state => cercaVistesReducer.getCercaVistes(state);

export const getVeureMenuLateral = state =>
  menuLateralReducer.getvisibilitatMenuGeneral(state);

export const getMunicipis = state => municipisReducer.getMunicipis(state);

//INDRETS
export const getIdIndret = state => indretsReducer.getIdIndret(state.dades);

export const getIndretPerId = state =>
  indretsReducer.getIndretPerId(state.indrets);

export const getPeticioIndretsEnCurs = state =>
  indretsReducer.getPeticioIndretsEnCurs(state.indrets);

export const getPeticioIndretsError = state =>
  indretsReducer.getPeticioIndretsError(state.indrets);

export const getIndretsLlistat = state =>
  indretsReducer.getIndretsLlistat(state.indrets);

export const getIndretsAsArray = state =>
  indretsReducer.getIndretsAsArray(state.indrets);

export const getMostrarErrorsIndret = state =>
  indretsReducer.getMostrarErrors(state.indrets);

export const getDadesEditadesIndret = state =>
  indretsReducer.getDadesEditades(state.indrets);

export const getDadesOriginalsIndret = state =>
  indretsReducer.getDadesOriginals(state.indrets);

export const getIdIndretLlista = state =>
  indretsReducer.getIdIndret(state.indrets);

export const getDadesIndret = state =>
  indretsReducer.getDadesIndret(state.indrets);

export const getPeticioEnviarFormulariIndretEnCurs = state =>
  indretsReducer.getPeticioEnviarFormulariIndretEnCurs(state.indrets);

export const getIndretsActius = state =>
  indretsReducer.getIndretsActius(state.indrets);

export const getIndretsInactius = state =>
  indretsReducer.getIndretsInactius(state.indrets);

export const getIndretFotosOriginals = state =>
  indretsReducer.getIndretFotosOriginals(state.indrets);

export const getIndretFotosEliminades = state =>
  indretsReducer.getIndretFotosEliminades(state.indrets);

export const getIndretFotosCreades = state =>
  indretsReducer.getIndretFotosCreades(state.indrets);

//INDIVIDUS
export const getIndividusLlistat = state =>
  individusReducer.getIndividusLlistat(state.individus);

export const getIdIndividuLlista = state =>
  individusReducer.getIdIndividu(state.individus);

export const getDadesOriginalsIndividu = state =>
  individusReducer.getDadesOriginals(state.individus);

export const getDadesEditadesIndividu = state =>
  individusReducer.getDadesEditades(state.individus);

export const getMostrarErrorsIndividu = state =>
  individusReducer.getMostrarErrors(state.individus);

export const getPeticioEnviarFormulariIndividuEnCurs = state =>
  individusReducer.getPeticioEnviarFormulariIndividuEnCurs(state.individus);

export const getDadesIndividu = state =>
  individusReducer.getDadesIndividu(state.individus);

export const obtenirCollectius = state =>
  collectiusReducer.getCollectius(state);

export const obtenirGeneres = state => generesReducer.getGeneres(state);

export const obtenirRegnes = state => regnesReducer.getRegnes(state);

export const obtenirVarietats = state => varietatsReducer.getVarietats(state);

export const obtenirSubEspecies = state =>
  subEspeciesReducer.getSubEspecies(state);

export const obtenirIndrets = state =>
  individusReducer.getDadesIndrets(state.individus);

export const getNumObservacions = state =>
  individusReducer.getNumObservacions(state.individus);
